angular.module( 'angus.directives' ).directive( 'acctGainLoss', [
	'actionViewTemplates',
	function( actionViewTemplates ) {
		'use strict';

		return {
			scope: {
				closeCb: '=',
				model: '=actionModel',
				settings: '=acctGainLossSettings',
				widgetCode: '='
			},
			templateUrl: actionViewTemplates.acctGainLossContainer
		};
	}
] );